import React from "react";
import { navigate, Link } from 'gatsby';
import axios from 'axios'
import styled from "styled-components";
import { StaticImage } from 'gatsby-plugin-image';
import { Checkbox, HelpText, Container } from "../Section";
import {FormWrap, FormTitle, FormSubTitle, FormRow, FormCol, FormTwoCol, FormAction} from "../FormStyle";
import PrimaryButton from "../Button/PrimaryButton";
import LineArrowRight from "../Icons/LineArrowRight"
import AddressGrid from "../AddressGrid"

const GetWrap = styled.div`
	position: relative;
	z-index:1;
	margin-top: 40px;
	margin-bottom: 40px;
	@media(min-width:992px){
		margin-bottom: -180px;
	}
`
const GetGrid = styled.div`
	position: relative;
	display: flex;
	align-items: center;	
	flex-direction: column;
	@media(min-width:992px){
		flex-direction: row;
	}
`
const GetLeftGrid = styled.div`	
	width: 100%;
	@media(min-width:992px){
		width: 75%;
	}
	.form{
		margin:0;
		@media(min-width:992px){
			width:65%;
		}
	}
`
const GetRightGrid = styled.div`	
	width: 100%;
	@media(min-width:992px){
		width: 50%;
		margin-left: -25%;
	}
`

const GetLeftBody = styled.div`
	background: #F7F5F5;
	border-radius: 6px;
	padding:30px 20px;
	@media(min-width:768px){
		padding:30px;
	}
	@media(min-width:1200px){
		padding: 40px;
	}
	@media(min-width:1600px){
		padding: 50px;
	}
`

const GetRightBody = styled.div`
	background: #D7272C;
	border-radius: 6px;	
	padding:30px 20px;
	@media(min-width:768px){
		padding:30px;
	}
	@media(min-width:1200px){
		padding: 40px;
	}
	@media(min-width:1600px){
		padding: 50px;
	}
`
const Brand = styled.div`
	margin-bottom:0;
`

class GetInTouch extends React.Component {
	constructor(props) {
		super(props)
		this.state={
		full_name: '',
		email: '',
		phone: '',
		zipcode: '',
		comment: '',
		agreeViaSms: true,
		}
		this.handleChange = this.handleChange.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
	}
  	componentDidMount() {
		if (typeof window !== 'undefined') 
		{
			const searchParams = new URLSearchParams(window.location.search);
			if(searchParams.get("utm_source")!='' && searchParams.get("utm_source")!=null)
			{
				sessionStorage.setItem('utm_source', searchParams.get("utm_source"));
				sessionStorage.setItem('utm_medium', searchParams.get("utm_medium"));
				sessionStorage.setItem('utm_campaign', searchParams.get("utm_campaign"));
				sessionStorage.setItem('utm_term', searchParams.get("utm_term"));
				sessionStorage.setItem('utm_content', searchParams.get("utm_content"));
			}
		}
	}
	handleChange(event) {
		const {id, value} = event.target
		if (id !== "agreeViaSms") {
			this.setState({
				[id]: value,
			})
		} else {
			this.setState({
				[id]: event.target.checked,
			})
		}
	}
  handleSubmit(event) {
	let utm_source_val = 'website';
	let utm_medium_val = '';
	let utm_campaign_val = '';
	let utm_term_val = '';
	let utm_content_val = '';
	if(sessionStorage.getItem('utm_source')!='' && sessionStorage.getItem('utm_source')!=null) 
	{
		utm_source_val = sessionStorage.getItem('utm_source');
		utm_medium_val = sessionStorage.getItem('utm_medium');
		utm_campaign_val = sessionStorage.getItem('utm_campaign');
		utm_term_val = sessionStorage.getItem('utm_term');
		utm_content_val = sessionStorage.getItem('utm_content');
	}
    event.preventDefault();
	const { location } = this.props;
    const data = {
		source: location.origin,
		form: "Get In Touch Form",
		page: location.pathname,
		first_name: this.state.full_name,
		email: this.state.email,
		phone_no: this.state.phone,
		zipcode: this.state.zipcode,
		comment: this.state.comment + ", SMS consent : " + this.state.agreeViaSms,
		agreeViaSms: this.state.agreeViaSms,
		utm_medium: utm_medium_val,
		utm_term: utm_term_val,
		utm_campaign: utm_campaign_val,
		utm_content: utm_content_val,
		lead_source: utm_source_val,
    }
	//console.log("==========", data)
    axios({
      method: "post",
       url: "https://crm.senseicrm.com/api/create-lead-wordpress",
       data: data,
       headers: { Authorization: "Bearer " + process.env.GATSBY_FORM_CRM_TOKEN }
     }).then((res) => {
       this.setState({ full_name: '', email: '', phone: '', zipcode: '', comment: '', agreeViaSms: false});
       navigate("/thank-you-get-in-touch");
     }).catch((error) => {
         alert(error)
     });
  }
  render() {
		return(
			<GetWrap>
				<Container>
					<GetGrid>
						<GetLeftGrid>
							<GetLeftBody>
								<FormTitle className="form-title" textAlign="left">Get In Touch</FormTitle>
								<FormSubTitle textAlign="left" maxWidth="550px">We not only fulfill your metal building needs, but we also make dreams come true.</FormSubTitle>
								<FormWrap className="form">
									<form id="GetInTouch" onSubmit={this.handleSubmit}>
										<FormRow className="form-row">
											<FormTwoCol className="form-coltwo">
												<div className="form-group">
													<input className="form-control" type="text" name="full_name" id="full_name" onChange={this.handleChange} placeholder="Full Name" pattern="^(?!\s*$)[A-Za-z\s]+$" required />
												</div>
											</FormTwoCol>
											<FormTwoCol className="form-coltwo">
												<div className="form-group">
													<input className="form-control" type="email" name="email" id="email" onChange={this.handleChange} placeholder="Email Id" required />
												</div>
											</FormTwoCol>
											<FormTwoCol className="form-coltwo">
												<div className="form-group">
													<input className="form-control" type="tel" name="phone" id="phone" onChange={this.handleChange} placeholder="Contact Number" pattern="[0-9]{10}" required />
												</div>
											</FormTwoCol>
											<FormTwoCol className="form-coltwo">
												<div className="form-group">
													<input className="form-control" type="number" name="zipcode" id="zipcode" onChange={this.handleChange} placeholder="Zip Code" pattern="^[0-9]{5}$" required />
												</div>
											</FormTwoCol>

											<FormCol>
												<div className="form-group">
													<textarea className="form-control" name="comment" placeholder="Comment" onChange={this.handleChange} id="comment" rows="4" required />
												</div>
											</FormCol>
											<FormCol>
												<div className="form-group-check">
													<Checkbox>
														<label><input className="form-control" type="checkbox" id="agreeViaSms" name="agreeViaSms" defaultChecked={true} onChange={this.handleChange} aria-label="contacted via SMS" /></label>
													</Checkbox>
													<HelpText>By submitting this form, I agree to receive text messages from Buildings And More. Standard messaging rates and data charges may apply. Message frequency may vary. You can opt-out by replying STOP at any time or reply HELP to get more information. See our <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms-and-conditions">Terms</Link>. We do not share your mobile info with third parties for marketing.</HelpText>
												</div>
											</FormCol>
										</FormRow>
										<FormAction className="form-action">
											<button type="submit"><PrimaryButton text="Submit" icon={<LineArrowRight />} /></button>
										</FormAction>
									</form>
								</FormWrap>
							</GetLeftBody>
						</GetLeftGrid>
						<GetRightGrid>
							<GetRightBody>
								<Brand><StaticImage src="../../images/whitelogo.png" placeholder="blurred" alt="white logo" /></Brand>
								<AddressGrid />
							</GetRightBody>
						</GetRightGrid>
					</GetGrid>
				</Container>
			</GetWrap>
		)
	}
}

export default GetInTouch;